import classNames from 'classnames';
import React from 'react';

import type {
  HeaderButtonLinkProps,
  HeaderButtonProps,
} from 'src/components/layout/redesign/header-mobile/header-button';
import HeaderButton from 'src/components/layout/redesign/header-mobile/header-button';

import * as styles from './header-bottom-nav.module.scss';

type HeaderMobileBottomNavProps = {
  isMenuOpen: boolean;
  primaryButton?: HeaderButtonProps;
  secondaryButton?: HeaderButtonProps;
  searchButton?: HeaderButtonProps;
  linkDropdownCta?: Queries.LinkDropdownCta;
};

const HeaderMobileBottomNav = ({
  isMenuOpen,
  primaryButton,
  secondaryButton,
  linkDropdownCta,
  searchButton,
}: HeaderMobileBottomNavProps) => {
  const showMobilePrimaryMenuButton =
    linkDropdownCta?.enabled &&
    linkDropdownCta?.mobilePrimaryMenuButton?.displayText &&
    linkDropdownCta?.mobilePrimaryMenuButton?.link;

  return (
    <div className={classNames(styles.wrapper, isMenuOpen && styles.menuOpen)}>
      {primaryButton &&
        (showMobilePrimaryMenuButton ? (
          <HeaderButton
            {...primaryButton}
            {...{
              buttonProps: {
                ...(primaryButton as HeaderButtonLinkProps).buttonProps,
                buttonLink: linkDropdownCta?.mobilePrimaryMenuButton.link,
                buttonText: linkDropdownCta?.mobilePrimaryMenuButton.displayText,
              },
            }}
            type="link"
            className={styles.button}
            contentClassName={styles.buttonContent}
          />
        ) : (
          <HeaderButton
            {...primaryButton}
            className={styles.button}
            contentClassName={styles.buttonContent}
          />
        ))}

      {secondaryButton && (
        <HeaderButton
          {...secondaryButton}
          className={styles.button}
          contentClassName={styles.buttonContent}
        />
      )}

      {searchButton && (
        <HeaderButton
          {...searchButton}
          className={classNames(styles.button, styles.searchButton)}
          contentClassName={styles.buttonContent}
        />
      )}
    </div>
  );
};

export default HeaderMobileBottomNav;
